import React, { useState } from "react";
import { motion } from "framer-motion";
import { RocketLaunchIcon } from "@heroicons/react/24/outline";
import EtModalContactConversation from "@/components/modal/EtModalContactConversation";

const EtTrinityExperienceCTA = () => {
  // First Created – 11 Nov 2025
  // Author – Atul Pandey
  // Purpose – Culminating CTA for Trinity Platform page

  const [open, setOpen] = useState(false);

  return (
    <section
      id="experience"
      className="py-24 bg-gradient-to-b from-black via-orange-700/10 to-black text-white text-center relative overflow-hidden"
    >
      {/* Subtle background texture + glow */}
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(255,115,0,0.15)_0%,transparent_70%)] animate-pulse" />

      <motion.div
        className="relative z-10 max-w-4xl mx-auto px-6 sm:px-8"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        {/* Headline */}
        <h2 className="text-3xl md:text-4xl font-bold mb-6 text-orange-500">
          The Experience
        </h2>

        {/* Narrative */}
        {/* 25 Nov 2025 */}
        <p className="text-lg md:text-xl text-orange-100 mb-6 leading-relaxed font-extralight">
          Trinity comes alive through <span className="font-bold text-orange-600">your energy and vision</span>.  
          The experience grows with the journey you imagine for yourself and your organization.

          <br /><br />

          Every growth path is unique, and its real momentum comes from leaders like you. 

          <br /><br />

          Rather than talking about it, why not <span className="font-semibold text-white">experience it together</span>?  
          
          <br /><br />
          
          Let’s begin a conversation.
        </p>

        {/* <p className="text-lg md:text-xl text-orange-100 mb-6 leading-relaxed font-extralight">
          Trinity is <span className="font-bold text-orange-600">lit up by you</span>! Its experience is shaped by the growth journey you envision — for yourself and your organization.
          We believe every growth curve is unique, and its true propulsion comes from leaders like you. So instead of talking, wouldn’t it be worth <span className="font-semibold text-white">experiencing it together</span>? Let’s build a conversation.
        </p> */}

        {/* <p className="text-lg md:text-xl text-orange-100 mb-6 leading-relaxed font-extralight">
          So instead of talking, wouldn’t it be worth <span className="font-semibold text-white">experiencing it together</span>? Let’s have a conversation.
        </p> */}

        {/* Eternity & Trinity Mission line
        <p className="text-base md:text-lg text-orange-200 mb-10">
          That’s what <strong>Eternity & Trinity</strong> aim to enable — helping CxOs build
          <span className="text-orange-400 font-semibold"> High Performance, Purpose Native</span> organizations.
          Trinity: <span className="italic">Thoughts re-imagined to naturally intensify your transformation</span>.
        </p> */}

        {/* CTA Button */}
        <motion.a
        //   onClick={() => setOpen(true)}
          href="/trinity/meet"
        //   className="inline-flex items-center gap-2 px-6 py-3 bg-orange-800 text-white font-semibold rounded-lg shadow-lg hover:bg-orange-600 transition cursor-pointer animate-pulse"
          className="inline-flex items-center gap-2 px-6 py-3 bg-orange-800 text-white font-semibold rounded-lg shadow-lg transition cursor-pointer animate-pulse"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <RocketLaunchIcon className="h-6 w-6" />
          Meet Trinity
        </motion.a>
        {/* {open && <EtModalContactConversation open={open} onClose={() => setOpen(false)} />} */}
      </motion.div>
    </section>
  );
};

export default EtTrinityExperienceCTA;